module.exports = __webpack_public_path__ + "img/rfx-logo.03ef46e4.svg";